import { FormikErrors } from 'formik';
import { CreateTransferPayOrderDto, PayOrderStatus, POS_CONFIRMED } from '@sr/dto';
import { VALIDATION_REQUIRED_FIELD } from 'utils/form-tools';

export type TransferFormData = {
  paymentDate: Date;
  description: string;
  outgoingDocumentNumber: string;
  incomingDocumentNumber: string;
  fromAccountId: number | '';
  toAccountId: number | '';
  amount: number | '';
  status: PayOrderStatus;
};

export const transferFormTools = {
  emptyValues: (): TransferFormData => ({
    paymentDate: new Date(),
    description: '',
    outgoingDocumentNumber: '',
    incomingDocumentNumber: '',
    fromAccountId: '',
    toAccountId: '',
    amount: '',
    status: POS_CONFIRMED
  }),

  toCreateDto: (values: TransferFormData): CreateTransferPayOrderDto => ({
    paymentDate: values.paymentDate,
    description: values.description.trim(),
    outgoingDocumentNumber: values.outgoingDocumentNumber.trim() || undefined,
    incomingDocumentNumber: values.incomingDocumentNumber.trim() || undefined,
    fromAccountId: Number(values.fromAccountId),
    toAccountId: Number(values.toAccountId),
    amount: Number(values.amount),
    status: values.status
  }),

  validate: (values: TransferFormData): FormikErrors<TransferFormData> => {
    const errors: FormikErrors<TransferFormData> = {};

    if (!values.paymentDate) errors.paymentDate = VALIDATION_REQUIRED_FIELD;
    if (!values.description.trim()) errors.description = VALIDATION_REQUIRED_FIELD;
    if (!values.fromAccountId) errors.fromAccountId = VALIDATION_REQUIRED_FIELD;
    if (!values.toAccountId) errors.toAccountId = VALIDATION_REQUIRED_FIELD;
    if (values.fromAccountId && values.toAccountId && values.fromAccountId === values.toAccountId) {
      errors.toAccountId = 'Счет зачисления должен отличаться от счета списания';
    }

    if (values.amount === '') {
      errors.amount = VALIDATION_REQUIRED_FIELD;
    } else if (isNaN(Number(values.amount))) {
      errors.amount = 'Сумма должна быть числом';
    } else if (Number(values.amount) <= 0) {
      errors.amount = 'Сумма должна быть больше нуля';
    }

    return errors;
  }
};
